/*
 * Copyright (c) 2024. Tooling Team
 */

import PropTypes from "prop-types";
import { Header } from "@uhg-abyss/web/ui/Header";
import { DropdownMenu } from "@uhg-abyss/web/ui/DropdownMenu";
import { AuthConsumer } from "../../providers/authProvider";
import { useEffect, useState } from "react";

const menuItems = [
  {
    title: "Log Out",
    onClick: () => {
      window.location.href = "/logout";
    },
  },
];

function UserDropdownMenu({ auth }) {
  const [username, setUsername] = useState("Account");
  useEffect(() => {
    let mounted = true;
    async function fetchUser() {
      try {
        const user = await auth.getUser();
        if (mounted) {
          setUsername(
            user?.profile?.preferred_username ||
              user?.profile?.name ||
              "Account"
          );
        }
      } catch (error) {
        // Optionally log the error and fall back to a safe default username
        // eslint-disable-next-line no-console
        console.error("Failed to fetch authenticated user", error);
        if (mounted) {
          setUsername("Account");
        }
      }
    }
    fetchUser();
    return () => {
      mounted = false;
    };
  }, [auth]);
  return (
    <DropdownMenu label={username} menuItems={menuItems} outline={false} />
  );
}

UserDropdownMenu.propTypes = {
  auth: PropTypes.shape({
    getUser: PropTypes.func.isRequired,
  }).isRequired,
};

export function MintHeader(props) {
  if (props.globalNav) {
    return (
      <AuthConsumer>
        {(auth) => (
          <Header.Container>
            <div className="logo-col mt-2andaBit logo-margin">
              <Header.Brandmark />
            </div>
            <div className="product-col mt-2andaBit product-name logo-margin">
              <h6>Mapping Intelligence and Normalization Toolkit</h6>
            </div>
            <Header.Actions>
              <UserDropdownMenu auth={auth} />
            </Header.Actions>
          </Header.Container>
        )}
      </AuthConsumer>
    );
  }

  return (
    <Header.Container>
      <Header.Brandmark />
    </Header.Container>
  );
}

MintHeader.propTypes = {
  globalNav: PropTypes.bool,
};

MintHeader.defaultProps = {
  globalNav: true,
};
